export const CMS_MODULES = [
	{
		id: 'journeys',
		title: 'Journeys',
		description: 'All live treks on the site — Everest, ABC, Langtang, Mustang, and 50+ more. Published = visitors can see it.',
		icon: 'fas fa-mountain',
		listPath: '/admin/cms/journeys',
		formPath: '/admin/cms/journey_form',
	},
	{
		id: 'destinations',
		title: 'Destinations',
		description: 'Cities, lakes, temples, national parks, UNESCO sites, and hidden gems.',
		icon: 'fas fa-map-marker-alt',
		listPath: '/admin/cms/destinations',
		formPath: '/admin/cms/destination_form',
	},
	{
		id: 'festivals',
		title: 'Festivals',
		description: 'Festival pages with dates, regions, galleries, and related places.',
		icon: 'fas fa-calendar-alt',
		listPath: '/admin/cms/festivals',
		formPath: '/admin/cms/festival_form',
	},
	{
		id: 'guides',
		title: 'Knowledge Guides',
		description: 'Visa, packing, permits, safety, transport, and other traveller guides.',
		icon: 'fas fa-book-open',
		listPath: '/admin/cms/guides',
		formPath: '/admin/cms/guide_form',
	},
	{
		id: 'media',
		title: 'Media Library',
		description: 'Images, videos, PDFs, GPX files — tagged and linked to content.',
		icon: 'fas fa-photo-video',
		listPath: '/admin/cms/media',
		formPath: '/admin/cms/media_form',
	},
	{
		id: 'sources',
		title: 'Official Sources',
		description: 'Government and authority URLs with last-verified dates.',
		icon: 'fas fa-university',
		listPath: '/admin/cms/official_sources',
		formPath: '/admin/cms/official_source_form',
	},
];

export const DESTINATION_CATEGORIES = [
	'national_park', 'unesco_site', 'lake', 'waterfall', 'temple', 'monastery', 'museum', 'viewpoint', 'other',
];

export const GUIDE_CATEGORIES = [
	'visa', 'insurance', 'packing', 'food', 'sim', 'transportation', 'money', 'shopping',
	'safety', 'emergency', 'culture', 'etiquette', 'permits', 'internet', 'health',
	'government', 'living_in_nepal', 'seasonal', 'festival', 'trends', 'arrival', 'trekking', 'temples',
];

export const FESTIVAL_DATE_TYPES = [
	{ value: 'fixed', label: 'Fixed date' },
	{ value: 'lunar_calculated', label: 'Lunar calendar' },
	{ value: 'variable', label: 'Variable / seasonal' },
];

export const JOURNEY_REGIONS = [
	'Everest & Khumbu', 'Annapurna', 'Langtang & Helambu', 'Manaslu & Ganesh',
	'Mustang & Dolpo', 'Far East', 'Far West', 'Kathmandu Valley & short treks',
	'Pilgrimage & culture', 'Wildlife & lowland',
];
